import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ICreditCheckPerson } from "utils/user";

type TInput = void;
type TOutput = Array<ICreditCheckPerson>;

export default class GetCreditCheckListApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri(): string {
    return `/fe-api/credit-check/list`;
  }

  mapResponseData(_: number, data: any): TOutput {
    return data.person.map(
      (x: any): ICreditCheckPerson => ({
        id: x.id,
        address: x.address,
        firstName: x.firstname,
        lastName: x.surname,
        isInProgress: x.is_spinner,
        birthDay: x.birthdate,
      }),
    );
  }
}
